import React, { useState } from 'react'
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../context/AuthContext';
import { Alert, Button, ButtonTypes, MoContainer, MoSpan, Input, MoLink } from '../Mo7/mo7UI';
import { cols, icons } from '../services/design.sevice';

export default function Signin() {
    const [{ email, password }, setInputValues] = useState({ email: "", password: "" })
    const history = useHistory()
    //Error and messages
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)
    const { signin, } = useAuth()
    //
    //const [username, ] = useState("")

    // function HandleAddusername(e) {
    //     e.preventDefault()

    //     database.users.add({
    //         //uid: currentUser.uid,
    //         username: username,
    //         age: 55
    //     })
    // }
    //
    function handleInputChange(e) {
        const { name, value } = e.target;
        setInputValues((prev) => ({
            ...prev, [name]: value
        }))
    }

    async function handleSignin(e) {
        e.preventDefault();

        //signin here
        var success = false;
        try {
            setError("")
            setLoading(true)
            await signin(email, password)
            success = true

        } catch {
            setError("Failed to sign in")
            success = false
        }

        if (success) {
            history.push("/dashboard/home")
        } else {
            setLoading(false)
        }
    }
    return (
        <MoContainer flex>
            <ContainerLHalf>

                <MoContainer gap="0" h="90%" flex_dir_c flex align="center" justify="center">
                    <MoSpan pd={{ tb: "1rem" }} >Welcome To</MoSpan>
                    <img src={icons.logo_text} alt="" />
                </MoContainer>
                <MoContainer w="100%">
                    <MoContainer flex pd={{ l: "2rem" }} >
                        <img height='20px' src={icons.ic_return} alt="" />
                        <MoLink to="/home">Home</MoLink>
                    </MoContainer>
                </MoContainer>
            </ContainerLHalf>
            <ContainerRHalf>
                <MoLink m_l="auto" to="/signup">
                    <MoContainer m_t="1rem" flex align="center">
                        I don't have an account
                            <Button w="10rem" b_r="5px" pd={{ lr: "15px" }} m_r="1rem" type={ButtonTypes.shadowed} title="Create Profile" />

                    </MoContainer>
                </MoLink>
                <ContainerSignForm>

                    <MoSpan pd={{ tb: "3rem" }}>Sign In</MoSpan>
                    <form onSubmit={handleSignin}>
                        <Input type="text" required value={email} onChange={handleInputChange} name="email" pholder="email" icon={icons.ic_email} />
                        <Input type="password" required onChange={handleInputChange} name="password" pholder="password" icon={icons.ic_password} />

                        <Button pd={{ lr: "3rem" }} type={ButtonTypes.filled} title="Signin" disabled={loading} />
                    </form>
                    <MoLink m_t="1rem" to="/forgot-password">Forgot password ? </MoLink>
                    {error && <Alert danger >{error}</Alert>}

                </ContainerSignForm>
                <MoContainer flex pos="fixed" pos_dir={{r:"1rem" ,b:'1rem'}} m_t='auto' >
                    <img width="100px" src={icons.logo1} alt="" />
                </MoContainer>

            </ContainerRHalf>


        </MoContainer>
    )
}

//#region styling

//#region Left half
const ContainerLHalf = styled.div`
    width: 50%;
    height: 100vh;
    background-color : ${cols.mainLight_1};
    display: flex;
    flex-direction: column;
    place-items :center;
    `;
//#endregion
//#region Righ half
const ContainerSignForm = styled.div`    
    display: flex;
    flex-direction: column;
    place-items :center;

    >form{
        display: flex;
        flex-direction: column;
        gap:1rem;
    }
    `;
const ContainerRHalf = styled.div`
    width: 50%;
    
    height: 100vh;
    background-color : white;
    
    display: grid;
    grid-template-rows: 1fr 5fr 1fr;
    
    `;
//#endregion


//#endregion